const Icons = {
  check: 'e900',
  checks: 'e901',
  activesessions: 'e902',
  add: 'e903',
  add_reaction: 'e904',
  addboost: 'e905',
  addmember_filled: 'e906',
  adduser: 'e907',
  admin: 'e908',
  ads: 'e909',
  ai_letters: 'e90a',
  ai_star1: 'e90b',
  ai_star2: 'e90c',
  ai_style_tone: 'e90d',
  align_center: 'e90e',
  align_left: 'e90f',
  align_right: 'e910',
  animals: 'e911',
  animations: 'e912',
  app_expand: 'e913',
  app_shrink: 'e914',
  archive: 'e915',
  archive_filled: 'e916',
  arrow_down: 'e917',
  arrow_next: 'e918',
  arrow_prev: 'e919',
  arrowcircle: 'e91a',
  arrowhead: 'e91b',
  attach: 'e91c',
  attach_edit: 'e91d',
  audio_repeat: 'e91e',
  audio_repeat_single: 'e91f',
  author_hidden: 'e920',
  auto_delete_circle_1: 'e921',
  auto_delete_circle_2: 'e922',
  auto_delete_circle_3: 'e923',
  auto_delete_circle_4: 'e924',
  auto_delete_circle_5: 'e925',
  auto_delete_circle_6: 'e926',
  auto_delete_circle_7: 'e927',
  auto_delete_circle_8: 'e928',
  auto_delete_circle_clock: 'e929',
  auto_delete_circle_days: 'e92a',
  auto_delete_circle_empty: 'e92b',
  auto_delete_circle_hours: 'e92c',
  auto_delete_circle_months: 'e92d',
  auto_delete_circle_off: 'e92e',
  auto_delete_circle_weeks: 'e92f',
  auto_delete_circle_years: 'e930',
  avatarnext: 'e931',
  avatarprevious: 'e932',
  aversion: 'e933',
  back: 'e934',
  backward_5: 'e935',
  bold: 'e936',
  bot_filled: 'e937',
  botcom: 'e938',
  bots: 'e939',
  brightness: 'e93a',
  brush: 'e93b',
  bubblereply: 'e93c',
  bug: 'e93d',
  calendar: 'e93e',
  calendarfilter: 'e93f',
  camera: 'e940',
  cameraadd: 'e941',
  captiondown: 'e942',
  captionup: 'e943',
  car: 'e944',
  card: 'e945',
  cash_circle: 'e946',
  channel: 'e947',
  channel_filled: 'e948',
  chatspinned: 'e949',
  check1: 'e94a',
  checkbox: 'e94b',
  checkboxblock: 'e94c',
  checkboxempty: 'e94d',
  checkboxon: 'e94e',
  checklist_add: 'e94f',
  checklist_done: 'e950',
  checklist_undone: 'e951',
  checkretract: 'e952',
  checkround: 'e953',
  checkround_filled: 'e954',
  clipboard: 'e955',
  close: 'e956',
  clouddownload: 'e957',
  collapse: 'e958',
  colorize: 'e959',
  comments: 'e95a',
  contrast: 'e95b',
  copy: 'e95c',
  crop: 'e95d',
  cross: 'e95e',
  crossgif: 'e95f',
  crossround: 'e960',
  crossround_filled: 'e961',
  crossstar: 'e962',
  crown: 'e963',
  crownoff: 'e964',
  darkmode: 'e965',
  darkmode_filled: 'e966',
  data: 'e967',
  delete: 'e968',
  delete_filled: 'e969',
  deleteleft: 'e96a',
  deleteuser: 'e96b',
  devices: 'e96c',
  document: 'e96d',
  dollar_circle: 'e96e',
  dollar_circle_x: 'e96f',
  down: 'e970',
  down_crossed: 'e971',
  down_up: 'e972',
  download: 'e973',
  dragfiles: 'e974',
  dragmedia: 'e975',
  eats: 'e976',
  edit: 'e977',
  edit_stars: 'e978',
  edit_stars_add: 'e979',
  email: 'e97a',
  endcall_filled: 'e97b',
  enhance: 'e97c',
  enter: 'e97d',
  equalizer: 'e97e',
  expand: 'e97f',
  eye: 'e980',
  faceid: 'e981',
  factcheck: 'e982',
  fade: 'e983',
  favourites: 'e984',
  filter: 'e985',
  fire: 'e986',
  flag: 'e987',
  flip: 'e988',
  flip_image_horizontal: 'e989',
  folder: 'e98a',
  fontframe: 'e98b',
  fontsize: 'e98c',
  forward: 'e98d',
  forward_25: 'e98e',
  forward_filled: 'e98f',
  free_transform: 'e990',
  fullscreen: 'e991',
  gc_microphone: 'e992',
  gc_microphoneoff: 'e993',
  gem: 'e994',
  gem_exchange: 'e995',
  gem_transfer: 'e996',
  geometric_digit_0: 'e997',
  geometric_digit_1: 'e998',
  geometric_digit_2: 'e999',
  geometric_digit_3: 'e99a',
  geometric_digit_4: 'e99b',
  geometric_digit_5: 'e99c',
  geometric_digit_6: 'e99d',
  geometric_digit_7: 'e99e',
  geometric_digit_8: 'e99f',
  geometric_digit_9: 'e9a0',
  geometric_dot: 'e9a1',
  geometric_letter_x: 'e9a2',
  gifs: 'e9a3',
  gift: 'e9a4',
  grain: 'e9a5',
  group: 'e9a6',
  group_filled: 'e9a7',
  group_star: 'e9a8',
  groupmedia: 'e9a9',
  groupmediaoff: 'e9aa',
  hand: 'e9ab',
  help: 'e9ac',
  hide: 'e9ad',
  highlights: 'e9ae',
  hourglass: 'e9af',
  image: 'e9b0',
  image_original: 'e9b1',
  info: 'e9b2',
  italic: 'e9b3',
  key: 'e9b4',
  keyboard: 'e9b5',
  lamp: 'e9b6',
  language: 'e9b7',
  left: 'e9b8',
  limit_folders: 'e9b9',
  limit_link: 'e9ba',
  link: 'e9bb',
  link_paid: 'e9bc',
  list: 'e9bd',
  livelocation: 'e9be',
  livestream: 'e9bf',
  location: 'e9c0',
  lock: 'e9c1',
  lockoff: 'e9c2',
  loginlogodesktop: 'e9c3',
  loginlogomobile: 'e9c4',
  logo: 'e9c5',
  logout: 'e9c6',
  mac_command_key: 'e9c7',
  mediaspeed_empty: 'e9c8',
  mediaspoiler: 'e9c9',
  mediaspoileroff: 'e9ca',
  mention: 'e9cb',
  menu: 'e9cc',
  menu_feature_cover: 'e9cd',
  menu_feature_unique: 'e9ce',
  menu_verification: 'e9cf',
  message: 'e9d0',
  message_jump: 'e9d1',
  message_quote: 'e9d2',
  messageunread: 'e9d3',
  microphone: 'e9d4',
  microphone_crossed: 'e9d5',
  microphone_crossed_filled: 'e9d6',
  microphone_filled: 'e9d7',
  minus: 'e9d8',
  monospace: 'e9d9',
  more: 'e9da',
  movetochats: 'e9db',
  movetomenu: 'e9dc',
  multistories: 'e9dd',
  mute: 'e9de',
  muted: 'e9df',
  mynotes: 'e9e0',
  newchannel: 'e9e1',
  newchannel_filled: 'e9e2',
  newchat_filled: 'e9e3',
  newgroup: 'e9e4',
  newgroup_filled: 'e9e5',
  newprivate: 'e9e6',
  newprivate_filled: 'e9e7',
  newtab: 'e9e8',
  next: 'e9e9',
  nochannel: 'e9ea',
  noncontacts: 'e9eb',
  online: 'e9ec',
  passwordoff: 'e9ed',
  permissions: 'e9ee',
  phone: 'e9ef',
  phone_filled: 'e9f0',
  pin: 'e9f1',
  pinlist: 'e9f2',
  pinned_filled: 'e9f3',
  pinnedchat: 'e9f4',
  pinnedchat_filled: 'e9f5',
  pip: 'e9f6',
  playback_05: 'e9f7',
  playback_15: 'e9f8',
  playback_1x: 'e9f9',
  playback_2x: 'e9fa',
  plus: 'e9fb',
  plusround: 'e9fc',
  poll: 'e9fd',
  premium_badge: 'e9fe',
  premium_lock: 'e9ff',
  premium_translate: 'ea00',
  previous: 'ea01',
  privacypolicy: 'ea02',
  promote: 'ea03',
  qr: 'ea04',
  quote: 'ea05',
  radiooff: 'ea06',
  radioon: 'ea07',
  reactions: 'ea08',
  reactions_filled: 'ea09',
  readchats: 'ea0a',
  recent: 'ea0b',
  redo: 'ea0c',
  reload_star: 'ea0d',
  replace: 'ea0e',
  reply: 'ea0f',
  reply_filled: 'ea10',
  restrict: 'ea11',
  revenue: 'ea12',
  rightpanel: 'ea13',
  rotate: 'ea14',
  rotate_left: 'ea15',
  rotate_right: 'ea16',
  round_chats_filled: 'ea17',
  saturation: 'ea18',
  savedmessages: 'ea19',
  schedule: 'ea1a',
  scheduled: 'ea1b',
  screen_crossed: 'ea1c',
  search: 'ea1d',
  search_check: 'ea1e',
  select: 'ea1f',
  send2: 'ea20',
  sending: 'ea21',
  settings: 'ea22',
  settings_clipped_corner: 'ea23',
  settings_filled: 'ea24',
  shadows: 'ea25',
  sharescreen_filled: 'ea26',
  sharingoff: 'ea27',
  sharingoff_filled: 'ea28',
  sharingon: 'ea29',
  sharpen: 'ea2a',
  shipping: 'ea2b',
  shuffle: 'ea2c',
  smallscreen: 'ea2d',
  smile: 'ea2e',
  sort_date: 'ea2f',
  sort_num: 'ea30',
  sort_price: 'ea31',
  speaker: 'ea32',
  speakeroff: 'ea33',
  spoiler: 'ea34',
  sport: 'ea35',
  star: 'ea36',
  star_filled: 'ea37',
  stickers: 'ea38',
  stickers_face: 'ea39',
  stop: 'ea3a',
  stories: 'ea3b',
  story: 'ea3c',
  storyreply: 'ea3d',
  storyrepost: 'ea3e',
  strikethrough: 'ea3f',
  suggested: 'ea40',
  tag: 'ea41',
  tag_add: 'ea42',
  tag_alt: 'ea43',
  tag_crossed: 'ea44',
  tag_filter: 'ea45',
  tag_name: 'ea46',
  text: 'ea47',
  textedit: 'ea48',
  tip: 'ea49',
  ton: 'ea4a',
  tools: 'ea4b',
  topics: 'ea4c',
  trade: 'ea4d',
  transcribe: 'ea4e',
  unarchive: 'ea4f',
  underline: 'ea50',
  undo: 'ea51',
  unmute: 'ea52',
  unpin: 'ea53',
  unread: 'ea54',
  up: 'ea55',
  up_down: 'ea56',
  user: 'ea57',
  username: 'ea58',
  videocamera: 'ea59',
  videocamera_crossed_filled: 'ea5a',
  videocamera_filled: 'ea5b',
  videochat: 'ea5c',
  vignette: 'ea5d',
  warmth: 'ea5e',
  webview: 'ea5f',
  zoomin: 'ea60',
  zoomout: 'ea61',
  account_filled: 'ea62',
  admin_filled: 'ea63',
  adult_crossed: 'ea64',
  adult: 'ea65',
  affiliate_filled: 'ea66',
  ai_filled: 'ea67',
  align_bottom: 'ea68',
  align_horizontal_center: 'ea69',
  align_left_edge: 'ea6a',
  align_right_edge: 'ea6b',
  align_top: 'ea6c',
  align_vertical_center: 'ea6d',
  android_filled: 'ea6e',
  appearance_filled: 'ea6f',
  apple_filled: 'ea70',
  apps_magic: 'ea71',
  apps: 'ea72',
  archive_box: 'ea73',
  arrow_left_square_add: 'ea74',
  arrow_left_square: 'ea75',
  arrow_right_circle: 'ea76',
  arrow_right_square_add: 'ea77',
  arrow_right_square: 'ea78',
  arrow_up_circle: 'ea79',
  arrow_up: 'ea7a',
  aspect_ratio_16_9: 'ea7b',
  aspect_ratio_3_2: 'ea7c',
  aspect_ratio_4_3: 'ea7d',
  aspect_ratio_5_4: 'ea7e',
  aspect_ratio_7_6: 'ea7f',
  auto_delete_circle_1_day: 'ea80',
  auto_delete_circle_1_month: 'ea81',
  auto_delete_circle_1_week: 'ea82',
  bath: 'ea83',
  bell_filled: 'ea84',
  bid_carryover: 'ea85',
  birthday_filled: 'ea86',
  bot_add: 'ea87',
  bounce: 'ea88',
  burger: 'ea89',
  business_filled: 'ea8a',
  cache_clear: 'ea8b',
  cake: 'ea8c',
  carousel: 'ea8d',
  chat_background: 'ea8e',
  circle_blocked: 'ea8f',
  clear: 'ea90',
  cloud: 'ea91',
  cookies_clear: 'ea92',
  copy_alt: 'ea93',
  copyright: 'ea94',
  data_transfer_filled: 'ea95',
  dislike: 'ea96',
  emoji_angry: 'ea97',
  emoji_happy: 'ea98',
  emoji_neutral: 'ea99',
  emoji_sad: 'ea9a',
  emoji_surprised: 'ea9b',
  emoji_thinking: 'ea9c',
  emoji_tongue: 'ea9d',
  exclamation_circle: 'ea9e',
  faq_filled: 'ea9f',
  fill: 'eaa0',
  folder_add: 'eaa1',
  folder_crossed: 'eaa2',
  folder_download: 'eaa3',
  folder_upload: 'eaa4',
  formula: 'eaa5',
  gift_filled: 'eaa6',
  gram_filled: 'eaa7',
  gram_refund: 'eaa8',
  gram: 'eaa9',
  group_circle_filled: 'eaaa',
  heading_1: 'eaab',
  heading_2: 'eaac',
  heading_3: 'eaad',
  heading_4: 'eaae',
  heading_5: 'eaaf',
  heading_6: 'eab0',
  heading: 'eab1',
  history_clear: 'eab2',
  image_add: 'eab3',
  image_crossed: 'eab4',
  key_filled: 'eab5',
  like: 'eab6',
  link_filled: 'eab7',
  linux_filled: 'eab8',
  list_bulleted: 'eab9',
  list_checked: 'eaba',
  list_numbered: 'eabb',
  live_photo_crossed: 'eabc',
  live_photo_play: 'eabd',
  live_photo: 'eabe',
  loop: 'eabf',
  magic_plus_circle: 'eac0',
  mention_filled: 'eac1',
  merge_horizontal: 'eac2',
  merge_vertical: 'eac3',
  message_add: 'eac4',
  message_away: 'eac5',
  message_crossed: 'eac6',
  message_minus: 'eac7',
  message_reaction: 'eac8',
  more_circle: 'eac9',
  parachute: 'eaca',
  party: 'eacb',
  pause_circle: 'eacc',
  photo_filled: 'eacd',
  pie_chart_filled: 'eace',
  pip_enter: 'eacf',
  pip_exit: 'ead0',
  plus_circle_filled: 'ead1',
  policy_filled: 'ead2',
  prompt: 'ead3',
  pull_quote: 'ead4',
  quote_crossed: 'ead5',
  replace_circles: 'ead6',
  shield_add: 'ead7',
  shield_crossed: 'ead8',
  shield_star: 'ead9',
  shield: 'eada',
  slash: 'eadb',
  sleep: 'eadc',
  square_crossed: 'eadd',
  star_circle_filled: 'eade',
  statistics_chart: 'eadf',
  statistics_growth: 'eae0',
  sticker_add: 'eae1',
  stories_add: 'eae2',
  stories_archive: 'eae3',
  stories_caption: 'eae4',
  stories_down: 'eae5',
  stories_filled: 'eae6',
  stories_like: 'eae7',
  stories_unarchive: 'eae8',
  stories_unlike: 'eae9',
  table_add: 'eaea',
  table: 'eaeb',
  text_add: 'eaec',
  text_block: 'eaed',
  text_crossed: 'eaee',
  toggle: 'eaef',
  two_factor_auth_filled: 'eaf0',
  ubuntu_filled: 'eaf1',
  upload: 'eaf2',
  user_allow_speak: 'eaf3',
  user_block: 'eaf4',
  user_check: 'eaf5',
  user_circle: 'eaf6',
  user_nearby_crossed: 'eaf7',
  user_nearby: 'eaf8',
  user_premium: 'eaf9',
  user_search: 'eafa',
  user_target: 'eafb',
  vacation: 'eafc',
  video_message_crossed: 'eafd',
  video_message: 'eafe',
  videocamera_crossed: 'eaff',
  wallet: 'eb00',
  wave: 'eb01',
  web_a_filled: 'eb02',
  web_filled: 'eb03',
  web_k_filled: 'eb04',
  web_tab: 'eb05',
  work: 'eb06',
  data_filled: 'eb07',
  card_filled: 'eb08',
  crown_filled: 'eb09',
  crownoff_filled: 'eb0a',
  eyecross: 'eb0b',
  fontframe_filled: 'eb0c',
  gem_transfer_filled: 'eb0d',
  media_font: 'eb0e',
  premium: 'eb0f',
  quote_filled: 'eb10',
  tag_alt_filled: 'eb11',
  devices_filled: 'eb12',
  email_filled: 'eb13',
  lamp_filled: 'eb14',
  limit_folders_filled: 'eb15',
  premium_lock_filled: 'eb16',
  topics_filled: 'eb17',
  add_chat_filled: 'eb18',
  arrow_up_circle_filled: 'eb19',
  bin_filled: 'eb1a',
  bomb_filled: 'eb1b',
  boost_filled: 'eb1c',
  boostcircle_filled: 'eb1d',
  boosts_filled: 'eb1e',
  channelviews_filled: 'eb1f',
  chatsplaceholder_filled: 'eb20',
  clock_filled: 'eb21',
  commentssticker_filled: 'eb22',
  crownalt_filled: 'eb23',
  deletedaccount_filled: 'eb24',
  eye1_filled: 'eb25',
  eye2_filled: 'eb26',
  fast_forward_filled: 'eb27',
  fast_rewind_filled: 'eb28',
  fontframe_bg_filled: 'eb29',
  gift_premium_filled: 'eb2a',
  info2_filled: 'eb2b',
  largepause_filled: 'eb2c',
  largeplay_filled: 'eb2d',
  limit_chat_filled: 'eb2e',
  limit_chats_filled: 'eb2f',
  limit_file_filled: 'eb30',
  limit_pin_filled: 'eb31',
  listscreenshare_filled: 'eb32',
  music_filled: 'eb33',
  nosound_filled: 'eb34',
  note_filled: 'eb35',
  okay_filled: 'eb36',
  pause_filled: 'eb37',
  person_filled: 'eb38',
  pin2_filled: 'eb39',
  play_filled: 'eb3a',
  poll_multiple_answers_filled: 'eb3b',
  premium_addone_filled: 'eb3c',
  premium_avatars_filled: 'eb3d',
  premium_colors_filled: 'eb3e',
  premium_double_filled: 'eb3f',
  premium_emoji_filled: 'eb40',
  premium_filesize_filled: 'eb41',
  premium_lastseen_filled: 'eb42',
  premium_limits_filled: 'eb43',
  premium_management_filled: 'eb44',
  premium_noads_filled: 'eb45',
  premium_privacy_filled: 'eb46',
  premium_reactions_filled: 'eb47',
  premium_restrict_filled: 'eb48',
  premium_speed_filled: 'eb49',
  premium_status_filled: 'eb4a',
  premium_stickers_filled: 'eb4b',
  premium_tags_filled: 'eb4c',
  premium_transcription_filled: 'eb4d',
  premium_unlock_filled: 'eb4e',
  premium_wallpaper_filled: 'eb4f',
  recordround_filled: 'eb50',
  saved_filled: 'eb51',
  send_filled: 'eb52',
  sendingerror_filled: 'eb53',
  speaker_filled: 'eb54',
  speakeroff_filled: 'eb55',
  statistics_filled: 'eb56',
  tag_alt_crossed_filled: 'eb57',
  time_lock_filled: 'eb58',
  timer_filled: 'eb59',
  unclaimed_filled: 'eb5a',
  unpack_filled: 'eb5b',
  volume_down_filled: 'eb5c',
  volume_mute_filled: 'eb5d',
  volume_off_filled: 'eb5e',
  volume_up_filled: 'eb5f',
  warning_filled: 'eb60',
  win_key_filled: 'eb61',
  general_filled: 'eb62',
  keyboard_filled: 'eb63',
  arrow_down_square_add: 'eb64',
  arrow_up_square_add: 'eb65',
  auto_delete_filled: 'eb66',
  bubble_filled: 'eb67',
  emoji_filled: 'eb68',
  faceid_filled: 'eb69',
  info_filled: 'eb6a',
  location_filled: 'eb6b',
  person_crossed_filled: 'eb6c',
  recent_actions_filled: 'eb6d',
  sputnik_filled: 'eb6e',
  sticker_filled: 'eb6f',
  table_borderless: 'eb70',
  table_column_crossed: 'eb71',
  table_crossed: 'eb72',
  table_row_crossed: 'eb73',
  table_striped: 'eb74',
  time_filled: 'eb75',
  lock_filled: 'eb76',
  message_filled: 'eb77',
  arrow_left_circle: 'eb78',
  aspect_ratio_square: 'eb79',
  filter_circle: 'eb7a',
  message_text: 'eb7b',
  replace_squares: 'eb7c',
  table_filled: 'eb7d',
  blockquote: 'eb7e',
  sort_name: 'eb7f',
  sort_online: 'eb80',
  ai_letters_plain: 'eb81',
  account_add_filled: 'eb82',
  flag_filled: 'eb83',
  group_star_filled: 'eb84',
  loop_filled: 'eb85',
  note_crossed: 'eb86',
  note: 'eb87',
  reload_star_filled: 'eb88',
  replace_circles_filled: 'eb89',
  reply_crossed: 'eb8a'
};

export default Icons;
